<template>
  <vue-snotify/>
  <router-view v-if="!GETTING_PROFILE"/>
  <Chatbot v-if="SHOW_CHATBOT"/>
</template>
<script>
import {nextTick} from "vue";
import {mapGetters} from "vuex";
import Chatbot from "@/components/QscChatbot.vue";

export default {
  components: { Chatbot },
  computed: {
    ...mapGetters(["GETTING_PROFILE","SHOW_CHATBOT"])
  },
  data() {
    return {
    loading: true
    }
  },
  async beforeCreate() {
    this.$store.commit("SET_GETTING_PROFILE", true)
    await this.$store.dispatch('GET_PROFILE', this.$router.currentRoute._value.params.tenant).then(()=> {


     this.$store.commit("SET_GETTING_PROFILE", false)
   });

  },

}
</script>

<style lang="scss">
@import 'styles/style';


@import "~@fortawesome/fontawesome-free/css/all.min.css";
.snotify-rightBottom {
  bottom: 85px !important; 
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.text-bg-dark {
  color: #fff!important;
  background-color: #343a40!important;
}
.text-bg-light {
  color: #000!important;
  background-color: #f8f9fa!important;
}
.text-bg-info {
  color: #000!important;
  background-color: #17a2b8!important;
}
.text-bg-warning {
  color: #000!important;
  background-color: #ffc107!important;
}
.text-bg-danger {
  color: #fff!important;
  background-color: #dc3545!important;
}
.text-bg-success {
  color: #fff!important;
  background-color: #28a745!important;
}
.text-bg-secondary {
  color: #fff!important;
  background-color: #6c757d!important;
}
.text-bg-primary {
  color: #fff!important;
  background-color: #007bff!important;
}
@import '~nprogress/nprogress.css';
:root {
  --primary-color: #20a8d8;
  --secondary-color: #c8ced3;
  --success-color: #4dbd74;
  --success-dark-color: #077F31;
  --danger-color: #f86c6b;
  --warning-color: #ffc107;
  --info-color: #63c2de;
  --light-color: #f0f3f5;
  --dark-color: #2f353a;
  --mid-dark-color: #a4a4a4;
}
#nprogress .bar {
  height: 3px !important;
}
.form-control:focus {
  color: var(--cui-input-focus-color, rgba(44, 56, 74, 0.95));
  background-color: var(--cui-input-focus-bg, #fff);
  outline: 0;

}
.form-select:focus {
  color: var(--cui-input-focus-color, rgba(44, 56, 74, 0.95));
  background-color: var(--cui-input-focus-bg, #fff);
  outline: 0;

}

.form-select-sm {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;

}
.dropdown-item.active, .dropdown-item:active {
  color: var(--cui-dropdown-link-active-color);
  text-decoration: none;
  background-color: #198df1;
}
.w-100 {
  width: 100% !important;
}
.w-90 {
  width: 90% !important;
}
.w-80 {
  width: 80% !important;
}
.w-70 {
  width: 70% !important;
}
.w-60 {
  width: 60% !important;
}
.w-100 {
  width: 100% !important;
}
.w-50 {
  width: 50% !important;
}
.w-40 {
  width: 40% !important;
}
.w-30 {
  width: 30% !important;
}
.w-20 {
  width: 20% !important;
}
.w-10 {
  width: 10% !important;
}
.data-table_spinner {
  width: 100%;
  text-align: center;
  transform: translate(0, 50%);
  position: relative
}
.small_spinner {
  width: 50%;
  text-align: center;
  position: relative;
  transform: translate(0, 20%);
  .spinner-border {
    width: 50px !important;
    height: 50px !important;
  }
}

.mx-datepicker-popup {
  max-width: 500px;
}

.category-tree-rows {
  padding-left: 1rem;
}


.btn-success ,.btn-danger, .btn-primary {
  color:white !important;
}
.btn-outline-danger:hover , .btn-outline-success:hover, .btn-outline-primary:hover {
  color : white;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.pagination {
  --cui-pagination-padding-x: 0.75rem;
  --cui-pagination-padding-y: 0.375rem;
  --cui-pagination-font-size: 1rem;
  --cui-pagination-color: #0d6efd;
  --cui-pagination-bg: #fff;
  --cui-pagination-border-width: 1px;
  --cui-pagination-border-color: #c4c9d0;
  --cui-pagination-border-radius: 0;
  --cui-pagination-hover-color: var(--cui-link-hover-color);
  --cui-pagination-hover-bg: #d8dbe0;
  --cui-pagination-hover-border-color: #c4c9d0;
  --cui-pagination-focus-color: var(--cui-link-hover-color);
  --cui-pagination-focus-bg: #d8dbe0;
  --cui-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(50, 31, 219, 0.25);
  --cui-pagination-active-color: #fff;
  --cui-pagination-active-bg: #0d6efd;;
  --cui-pagination-active-border-color: #0d6efd;;
  --cui-pagination-disabled-color: #0d6efd;;
  --cui-pagination-disabled-bg: #e1e1e1;;
  --cui-pagination-disabled-border-color: #c4c9d0;
  display: flex;
  list-style: none;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #9ed2ba;
    }
    .router-link-active {
      background-color: #42b983;
    }
  }
}

.tab-pane:active,
.tab-pane:focus {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.tab-content {

  padding: 15px;
}
.nav-tabs {
  .nav-link {
    color: black !important;
  }
}

element.style {
}


</style>
